import Print from 'ol-ext/control/Print'

class CustomPrint extends Print {
  constructor (options) {
    if (!options) options = {}
    // this.viewer = options.viewer || null

    // on créer un fake target pour que le print controle ne crée pas un bouton
    options.target = document.createElement('span')
    super(options)
    // Print.call(this, options)
  }
}

export default CustomPrint
